module.exports = __webpack_public_path__ + "static/media/ibd_hips2.f4ba6c85.png";